import React from 'react'
import withView from '../../../cmn/docAutomation/withView';
import FormDialog from '../../../../library/form/components/FormDialog';
import FormTitle from '../../../../library/form/components/FormTitle'
import TaskCMNHeaderEditor from "./TaskCMNHeaderEditor"

const TaskHeaderEditor = (props) => {
    const { formObject, viewData, ...restProps } = props;

    if(!viewData)
        return(null);

    return (
        
        <FormDialog onDynamicViewClose={restProps.onDynamicViewClose} enablePopup={true}
            action={{ formActions: { forAction: "Confirm", forCancel: "Cancel" } }}
            formStyle={{ width: '715px' }}
            contentStyle={{ height: '505px',overflowY: "scroll" }}
            formTitle={<FormTitle formObject={formObject} value='Task Header' />}
            formObject={formObject} 
            >

            <TaskCMNHeaderEditor formObject={formObject} viewData={viewData} {...restProps}  />

        </FormDialog>
    )
}

export default withView(TaskHeaderEditor, "taskHeader", "taskHeader,taskDetail,docAttributeValue")

